/**
 * News / Blog Article 列表（`GET /contents/ranking`）时间窗，过滤 2026-05-21 之前的内容。
 * 不用于财报日历、AlphaPicks 等场景。
 */
/** UTC 2026-05-21 00:00:00 */
export const RANKING_CONTENTS_START_TIME_MS = Date.UTC(2026, 4, 21);

/** UTC 2099-12-31 00:00:00 */
export const RANKING_CONTENTS_END_TIME_MS = Date.UTC(2099, 11, 31);

type RankingContentsTimeFields = {
  start_time?: number;
  end_time?: number;
};

/**
 * 为 News / Article 类 `GET /contents/ranking` 补全默认时间窗；调用方已传 `start_time` / `end_time` 时保留原值。
 */
export function withRankingContentsTimeWindow<
  T extends RankingContentsTimeFields & Record<string, unknown>,
>(params: T): T & { start_time: number; end_time: number } {
  return {
    ...params,
    start_time: params.start_time ?? RANKING_CONTENTS_START_TIME_MS,
    end_time: params.end_time ?? RANKING_CONTENTS_END_TIME_MS,
  };
}
